import { usePathname, type ExpoRouter } from 'expo-router'
import { useAccountCreationStore } from '@/src/common/store/useAccountCreationStore'
import { useEffect } from 'react'
import { useAppState } from '@/src/common/hooks/useAppState'

export function useTrackAccountCreationPage() {
  const { setAccountCreationStep } = useAccountCreationStore()
  const pathname = usePathname()
  const { isAppVisible } = useAppState()
  /** Set the account creation step based on the current pathname */
  useEffect(() => {
    // @todo unuse this `as` cast
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    setAccountCreationStep(pathname as ExpoRouter.__routes['href'])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAppVisible])
}
